var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.count == 0)?_c('div',{staticClass:"text-2xl"},[_vm._v("No records missing "+_vm._s(_vm.field)+" information.")]):_c('div',{staticClass:"text-2xl mb-2"},[_vm._v(_vm._s(_vm.count)+" records missing "+_vm._s(_vm.field)+" information")])])
}
var staticRenderFns = []

export { render, staticRenderFns }